import React, { SetStateAction, useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import { NotSelected, DefaultGroupList } from "../../../Constant/Setting";
import { useDispatch } from "react-redux";
import { Params, useParams } from "react-router-dom";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import MetaInstance, { MetaMultipartInstance } from "../../../Services/AxiosInstance/MetaInstance";
import { GET_AGENT, GET_GROUP } from "../../../Services/Endpoint";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { GroupOld } from "../../../Shared-ui/Types/common";
import { isOnlyAlphabets } from "../../../Shared-ui/utils/Common/Common";



interface MyComponentProps {

}


const BasicDetails: React.FC<MyComponentProps> = (props) => {
  const [group, setGroup] = useState(""); // State for the group select dropdown
  const [icon, setIcon] = useState<string | null>(null); // State for image
  const [groupList, setGroupList] = useState([])
  const [knowledgeBase, setknowledgeBase] = useState<OldAgent>({
    "id": "",
    "name": "",
    "group": "",
    "description": "",
  })
  const [agentFormErr, setAgentFormErr] = useState({
    description: { error: "", value: false },
  });

  const { agentId } = useParams<Params>();

  const dispatch = useDispatch();
  useEffect(() => {
    getknowledgeBase()
    getGroups()
  }, [agentId])



  const getknowledgeBase = async () => {
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.get(`${GET_AGENT}/${agentId}`).then(res => res?.data?.detail)
      setknowledgeBase(data.response)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())

    }
  }

  const updateknowledgeBase = async () => {
    if(!validateAgentDetails()) return;
    try {
      dispatch(StartLoading())
      const payload = knowledgeBase
      if (knowledgeBase?.icon && knowledgeBase?.icon instanceof File) {
        const form = new FormData()
        form.append('file', knowledgeBase.icon)
        const iconData = await MetaMultipartInstance.post(`${GET_AGENT}/${agentId}/icon`, form).then(res => res?.data?.detail)
        delete payload?.icon
      }
      const data = await MetaInstance.put(`${GET_AGENT}/${agentId}`, payload).then(res => res?.data?.detail)
      getknowledgeBase()
      setIcon(null)
      dispatch(ShowSuccess(data?.response))
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())

    }
  }

  const validateAgentDetails = () => {
    // description

    if (!knowledgeBase.description.trim()) {
      setAgentFormErr((preVal) => ({
        ...preVal,
        description: { error: "Enter The Agent description", value: true },
      }));
      return false;
    } else if (knowledgeBase.description.length < 5) {
      setAgentFormErr((preVal) => ({
        ...preVal,
        description: {
          error: "Enter description Minimum 5 Character",
          value: true,
        },
      }));
      return false;
    } else if (!isOnlyAlphabets(knowledgeBase.description)) {
      setAgentFormErr((preVal) => ({
        ...preVal,
        description: { error: "Enter A-z Characters", value: true },
      }));
      return false;
    } else {
      setAgentFormErr((preVal) => ({
        ...preVal,
        description: { error: "", value: false },
      }));
      return true
    }
  }
  const getGroups = async () => {
    try {
      dispatch(StartLoading())
      //const data = await MetaInstance.get(`${GET_GROUP}`).then(res => res?.data?.detail)
      //const groupNames = data.response?.map((item: Group) => item.name)
      const pages = 1;
      const pageSizes = 100;
      const searchTexts = "";
      const groupGata = await MetaInstance.get(`${GET_GROUP}?page=${pages}&limit=${pageSizes}&search=${searchTexts}`).then(res => res?.data?.detail)
      const groupNameList = groupGata.response?.map((item: GroupOld) => item.name)
      setGroupList(groupNameList)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())

    }
  }


  // Handle image upload
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setknowledgeBase((prevState: any) => ({ ...prevState, icon: file }));
      setIcon(imageUrl); // Update state with uploaded image URL
    }
  };


  // Handle text field changes
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement> | SelectChangeEvent) => {
    const { name, value } = event.target;
    setknowledgeBase((prevState: any) => ({ ...prevState, [name]: value }));
  };

  return (
    <Box
      sx={{
        maxWidth: "970px",
      }}
    >
      {/* Section Title */}
      <Typography variant="h6" gutterBottom>
        Agent Details
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Update your Basic agent information.
      </Typography>

      {/* Main Section */}
      <Box
        sx={{
          display: "flex",
          marginTop: 4,
          gap: 6,
        }}
      >
        {/* Image Upload Section */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Avatar
            src={icon ? icon : `data:image/*;base64,${knowledgeBase?.icon}`}
            sx={{
              width: 120,
              height: 120,
              borderRadius: "10px",
            }}
            alt="Agent icon"
          />
          {/* {!icon && knowledgeBase?.icon && (
            <Avatar
              src={`data:image/*;base64,${knowledgeBase?.icon}`}
              sx={{
                width: 120,
                height: 120,
                borderRadius: "10px",
              }}
              alt="Agent icon"
            />
          )}
          {!knowledgeBase?.icon && icon && (
            <Avatar
              src={icon}
              sx={{
                width: 120,
                height: 120,
                borderRadius: "10px",
              }}
              alt="Agent icon"
            />
          )}
           */}

          <Button
            disableElevation
            variant="contained"
            component="label"
            sx={{ textTransform: "none" }}
          >
            Upload Icon
            <input
              type="file"
              name="image"
              hidden
              accept="image/*"
              onChange={(e) => handleImageChange(e)}
            />
          </Button>
        </Box>



        {/* Form Section */}
        <Box sx={{ flex: 1 }}>
          {/* Agent Name Field */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xl: "1fr 1fr",
                lg: "1fr 1fr",
                md: "1fr",
              },
              gap: 3,
              gridAutoRows: "1fr",
            }}
          >
            <Box sx={{ marginBottom: 3 }}>
              <FormControl fullWidth>
                <InputLabel
                  htmlFor="name"
                  shrink
                  sx={{ background: "#fff", px: 0.5 }}
                >
                  Agent Name
                </InputLabel>
                <TextField
                  id="name"
                  name="name"
                  disabled={true}
                  value={knowledgeBase?.name}
                  placeholder="Enter the agent name"
                  onChange={(e) => handleChange(e)}
                  sx={{ background: "white" }}
                />
              </FormControl>
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: 3,
                marginBottom: 3,
              }}
            >
              <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
                <FormControl fullWidth>
                  <InputLabel
                    id="group-select-label"
                    shrink
                    sx={{
                      background: "#fff",
                      px: 0.5,
                    }}
                  >
                    Group
                  </InputLabel>
                  <Select
                    labelId="group-select-label"
                    id="group-select"
                    name="group"
                    value={knowledgeBase?.group || ""}
                    onChange={handleChange}
                    sx={{ background: "white" }}
                    disabled // Disable since need some changes in the Backend to use
                  >
                    {groupList.map((item, index) => (
                      <MenuItem value={item} key={index}>{item}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <Button
                variant="outlined"
                startIcon={<AddIcon sx={{ marginRight: "-12px" }} />}
                sx={{ textTransform: "none" }}
              ></Button> */}
              </Box>
            </Box>
          </Box>

          <Box sx={{ marginBottom: 3 }}>
            <FormControl
              fullWidth
              variant="outlined"
              error={agentFormErr.description.value}
            >
              <InputLabel
                htmlFor="description"
                shrink
                sx={{ background: "#fff", px: 0.5 }}
              >
                Description
              </InputLabel>
              <TextField
                id="description"
                name="description"
                value={knowledgeBase?.description}
                onChange={(e) => handleChange(e)}
                placeholder="Enter description "
                multiline
                rows={4}
                error={agentFormErr.description.value}
                sx={{ background: "white" }}
                //onChange={handleChange}
                //error={loginErr.email.value}
                helperText={agentFormErr.description.error}
              />
            </FormControl>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "flex-end",
              pt: "0",
            }}
          >
            <Button
              variant="contained"
              disableElevation
              size="large"
              autoFocus
              sx={{
                textTransform: "capitalize",
              }}
              onClick={() => updateknowledgeBase()}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Box >
  );
};

export default BasicDetails;
